export const shopId = window.SHOP_ID || process.env.REACT_APP_SHOP_ID;
export const shop = window.SHOP || {};
export const apiHost =
  window.API_HOST || process.env.REACT_APP_API_HOST || window.location.origin;
export const baseUrl = window.BASEURL || process.env.REACT_APP_BASEURL || "";
export const baseRoute =
  window.BASE_ROUTE || process.env.REACT_APP_BASE_ROUTE || "";
export const liffId = window.LIFF_ID || process.env.REACT_APP_LIFF_ID;

export const lineOAUrl =
  window.LINE_AT_URL || process.env.REACT_APP_LINE_URL || "";
export const GA_trackId =
  window.TRACKING_ID || process.env.REACT_APP_TRACKING_ID || "";
export const stage = process.env.NODE_ENV || "";
export const SMS_CODE = "0000";

export const GA_CATEGORY = "laprairie-gift-2024";
export const GA_UTM_SOURCE = "utm_source";
export const GA_UTM_MEDIUM = "utm_medium";
export const GA_UTM_CAMPAIGN = "utm_campaign";
export const GA_UTM_TERM = "utm_term";
export const GA_UTM_ID = "utm_id";
export const GO_FORM_UTM_SOURCE = "ad";

export const verifyState = {
  UNVERIFY: "UNVERIFY",
  VERIFYING: "VERIFYING",
  VERIFIED: "VERIFIED",
};

export const verifyStateText = {
  UNVERIFY: "驗證",
  VERIFYING: "驗證",
  VERIFIED: "已驗證",
};

export const customerStatus = {
  REDEEMED: "REDEEMED",
  NOT_REDEEMED: "SUBMIT",
  UNAUTHORIZED: "UNAUTHORIZED",
};

export const phoneExpireTime = 15 * 60 * 1000;

export const expireTime = "2024/04/30";
export const Annotation = {
  Type: {
    INPUT: "INPUT",
    ITEM_LIST: "ITEM_LIST",
    DATE: "DATE",
    OPTIONS: "OPTIONS",
    ORDERER: "ORDERER",
    BRANCH: "BRANCH",
    STORE_SEVEN: "STORE_SEVEN",
    STORE_FAMILY: "STORE_FAMILY",
    COUPON: "COUPON",
    POINT: "POINT",
    CHECKBOX: "CHECKBOX",
    RADIO: "RADIO",
  },
};

console.log(stage);
